import { render, staticRenderFns } from "./WidgetAlerta.vue?vue&type=template&id=91f8314c&"
import script from "./WidgetAlerta.vue?vue&type=script&lang=ts&"
export * from "./WidgetAlerta.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetAlerta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('91f8314c', component.options)
    } else {
      api.reload('91f8314c', component.options)
    }
    module.hot.accept("./WidgetAlerta.vue?vue&type=template&id=91f8314c&", function () {
      api.rerender('91f8314c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Alerta/WidgetAlerta.vue"
export default component.exports